let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aT0co")).then(() => parcelRequire('2jxRj'));